module.exports = __webpack_public_path__ + "img/9788954622806.4c568d28.jpg";